import script from "./AppContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppContextMenu.vue?vue&type=style&index=0&id=037cb5bf&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037cb5bf"]])

export default __exports__